export function requestToQueryString(request: any): string {
  let result = '';
  Object.keys(request).forEach(key => {
    if (request[key] != null && request[key] !== '') {
      result += `${key}=${request[key]}&`;
    }
  });
  return result;
}
